import { reverb_config_cache_AddressFormConfig } from '@reverbdotcom/commons/src/gql/graphql';
import { Config, Field } from './address_form_fields_types';

function buildInputName(prefix: string, name: string) {
  if (prefix) {
    return `${prefix}[${name}]`;
  }

  return name;
}

function configFields(countryCode: string, configs: reverb_config_cache_AddressFormConfig[], requiredFieldsOverrides): Field[] {
  if (!configs) return;

  const formattedConfigs = formatAddressFieldsConfigs(configs);
  const isRegionNotRequired = () => { return !Object.hasOwnProperty(formattedConfigs[countryCode])?.hasOwnProperty('region'); };

  if (isRegionNotRequired() && requiredFieldsOverrides.includes('region')) {
    return formattedConfigs.default;
  } else {
    return formattedConfigs[countryCode] || formattedConfigs.default;
  }
}

function formatAddressFieldsConfigs(configs): Config {
  if (!configs) return;

  return configs.reduce((prev, config) => {
    const { fields } = config;

    return {
      ...prev,
      [config.countryCode]: fields.map(field => {
        return {
          fieldName: field.fieldName,
          display: field.displayNames.reduce((prev, display) => ({ ...prev, [display.locale]: display.displayName }), {}),
          required: field.required,
        };
      }),
    };
  }, {});
}

export {
  buildInputName,
  configFields,
  formatAddressFieldsConfigs,
};
